/** #1071 — page-lifetime record of the line each spread/total row was SEEDED
 *  on (the highest-volume rule, or the 50¢ line it fell back to), by the board
 *  or by Game Detail, so Back, a remount and the other surface reuse it
 *  instead of seeding again. A default, never a pick: it is
 *  kept apart from `spreadTotalLineMemory` because that memory marks a game as
 *  worked (full-ladder streaming) and is what Recent views restore. Same scope
 *  key and entry key; cleared in the same auth reset. Never written to disk. */
type Kind = 'spread' | 'total';
type Seeded = { scope: string; kind: Kind; event: string; line: string };
const MAX_DEFAULTS = 2048;
const defaults = new Map<string, Seeded>();
const key = (scope: string, kind: Kind, event: string) => JSON.stringify([scope, kind, event]);

export function rememberSpreadTotalDefault(
  scope: string | null, kind: Kind, event: string, line: string,
): void {
  if (!scope) return;
  const id = key(scope, kind, event);
  defaults.delete(id);
  defaults.set(id, { scope, kind, event, line });
  while (defaults.size > MAX_DEFAULTS) defaults.delete(defaults.keys().next().value!);
}

export function spreadTotalDefault(scope: string | null, kind: Kind, event: string): string | undefined {
  return scope ? defaults.get(key(scope, kind, event))?.line : undefined;
}

export function resetSpreadTotalLineDefaults(): void {
  defaults.clear();
}
